export default "__VITE_ASSET__BzL5ioK___"